import ms from 'ms'
import React, { createContext, ReactNode, useContext, useState } from 'react'

import Notification from '@/components/TailwindUI/Notification'

type NotificationInfo = {
  variant: 'success' | 'info' | 'error' | 'warning'
  title: string
  body: string | React.ReactNode
  duration?: string
}
type NotificationContextType = {
  notify: (notificationInfo: NotificationInfo) => void
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

type NotificationProviderProps = {
  children: ReactNode
}
export function NotificationProvider({ children }: NotificationProviderProps) {
  const [showNotification, setShowNotification] = useState(false)
  const [notificationInfo, setNotificationInfo] = useState<NotificationInfo>({ variant: 'info', title: '', body: '' })

  function notify({ variant, title, body, duration = '5 seconds' }: NotificationInfo) {
    setShowNotification(true)
    setNotificationInfo({ variant, title, body })
    setTimeout(() => setShowNotification(false), ms(duration))
  }

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <Notification
        show={showNotification}
        onClose={() => setShowNotification(false)}
        variant={notificationInfo.variant}
        title={notificationInfo.title}
      >
        {notificationInfo.body}
      </Notification>
    </NotificationContext.Provider>
  )
}

export function useNotification() {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider')
  }

  return context
}
